export const messages = {
  en: {
    staffAttendance: {
      monthPlaceholder: 'Select month',
      orgPlaceholder: 'Select organization',
      staffPlaceholder: 'Staff name',
      replenish: 'Replenish',
      work: 'Work',
      offWork: 'Off work',
      log: 'Attendance log',
      notTime: 'Not time yet',
      noNeed: 'No need',
      noTask: 'No replenish task',
      chooseOrg: 'Select Organization',
      loadOrgFailed: 'Failed to load organizations',
      selectOrgFirst: 'Please select an organization first',
      attendanceDetail: 'Attendance Details',
      staffName: 'Staff Name',
      face: 'Face',
      clockTime: 'Clock Time',
      loadDetailFailed: 'Failed to load attendance details',
      replenishCheckIn: 'Replenish Attendance',
      attendanceTask: 'Attendance Task',
      selectTask: 'Please select task',
      selectTaskFirst: 'Please select a task first',
      reason: 'Reason',
      inputReason: 'Please input reason',
      inputReasonFirst: 'Please input reason first',
      submitReplenish: 'Submit Replenish',
      replenishSuccess: 'Replenish successfully',
      replenishFailed: 'Replenish failed'
    }
  },
  zh: {
    staffAttendance: {
      monthPlaceholder: '请选择月份',
      orgPlaceholder: '请选择组织',
      staffPlaceholder: '员工名称',
      replenish: '补考勤',
      work: '上班',
      offWork: '下班',
      log: '考勤记录',
      notTime: '未到时间',
      noNeed: '无需考勤',
      noTask: '不存在补考勤任务',
      chooseOrg: '选择组织',
      loadOrgFailed: '加载组织失败',
      selectOrgFirst: '请先选择组织',
      attendanceDetail: '考勤明细',
      staffName: '员工名称',
      face: '人脸',
      clockTime: '考勤时间',
      loadDetailFailed: '加载考勤明细失败',
      replenishCheckIn: '补考勤',
      attendanceTask: '考勤任务',
      selectTask: '请选择考勤任务',
      selectTaskFirst: '请先选择考勤任务',
      reason: '原因',
      inputReason: '请填写原因',
      inputReasonFirst: '请先填写原因',
      submitReplenish: '提交补考勤',
      replenishSuccess: '补考勤成功',
      replenishFailed: '补考勤失败'
    }
  }
}